import React from "react";
import { Link as RLink } from "react-router-dom";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import modulockerImg from "assets/images/modulocker.png";

const Title = styled.span`
  display: block;
  font-size: 4rem;
  font-weight: 600;
  color: var(--black);
`;

const Link = styled(RLink)`
  cursor: pointer;
  font-weight: 500;
  color: #2b7de9;
`;

export default function ExpiredSession() {
  return (
    <Grid
      container
      alignItems="center"
      style={{ background: "var(--grayLv6)", height: "100vh" }}
      justifyContent="center"
    >
      <Grid item xs={12} sm={6} style={{ textAlign: "center" }}>
        <img src={modulockerImg} alt="Modulocker" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Title>Ooops!</Title>
        <p>
          Página não encontrada. Clique <Link to="/dashboard"> aqui </Link> para
          retornar a dashboard.
        </p>
      </Grid>
    </Grid>
  );
}
